import {Utilities} from '@shared/utilities/utilities.model';
import {FileMimeTypeModel} from '@shared/models/file-mime-type.model';

export class AuthorityAttachment {
	blobName: string;
	blobType: string;
	description: string;
	fileName: string;
	fileSize: string;
	mimeType: FileMimeTypeModel;
	resourceId: string;
	resourceType: string;
	status: string;
	thumbnailId: string;
	uuid: string;
	userFirstName: string;
	userLastName: string;
	createdAt: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.blobName = model.blob_name;
			this.blobType = model.blob_type;
			this.description = model.description;
			this.fileName = model.file_name;
			this.fileSize = model.file_size;
			this.mimeType = model.mime_type;
			this.resourceId = model.resource_id;
			this.resourceType = model.resource_type;
			this.status = model.status;
			this.thumbnailId = model.thumbnail_id;
			this.uuid = model.uuid;
			this.userFirstName = model.user_first_name;
			this.userLastName = model.user_last_name;
			this.createdAt = model.created_at;
		}
	}
}
